import { t } from 'i18next'
import { DeviceCard } from 'mobily-ui-library/lib'

import './Device.scss'
import pageLanguage from '../../functions/pageLanguage'

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const Device = (props: { data: { category: any; stockStatus: any } }) => {
 const win: any = window;
  win.dataLayer = win.dataLayer || [];
  const lang = pageLanguage()
  const ar = lang === "ar"

  const localhost = win.location.hostname === 'localhost'
  const serverURL = localhost ? 'http://ssta004:8080' : win.location.origin

  const { category, stockStatus } = props.data
  const { name, deviceSubType, minPrice, brand, preOrder, defaultURL, technicalURL, id } = category

  const title = ar ? name.valueAr : name.valueEn
  const price = `${t('from')} ${t('SAR')} ${minPrice}`
  const deviceManufacturer = ar ? brand.valueAr : brand.valueEn
  const preOrderTag = preOrder ? t('preOrder') : ''
  const soldOut = stockStatus.valueEn === "Out of Stock"
  const soldOutTag = soldOut ? t('soldOut') : undefined;
  const colors = category.colorCode?.map((color: { code: any; }) => color.code)
  const prefix = ar ? '/web/ar' : '/web/en'

  const gtmPushSelectItemEvent = () => {
    let itemCategory = deviceSubType.valueEn
    if (itemCategory === "Smart Phones") itemCategory = "Phones"
    if (itemCategory === "Smart Watches") itemCategory = "Wearables"

    win.dataLayer.push({ ecommerce: null });
    win.dataLayer.push({
      "event": "select_item",
      "ecommerce": {
        "user_id": "",
        "login_type": "not_logged_in",
        "screen_type": "devices-homepage",
        "screen_name": "devices-homepage",
        "language_selected": ar ? "AR" : "EN",
        "currency": "SAR",
        "items": [{
          "item_name": name.valueEn,
          "item_category": itemCategory,
          "price": minPrice,
          "item_id": id,
          "item_variant": "",
          "index": 0,
          "item_brand": brand.valueEn,
          "currency": "SAR",
          "item_list_name": "Phones and Accessories",
          "Order_type": preOrder ? "Pre-order" : "Order",
          "Device_availability": stockStatus.valueEn === "Out of Stock" ? "No" : "Yes",
          "quantity": 1
        }],
      }
    })
  }

  const onCardClick = () => {
         try {
      win.MixpanelTracker.trackEvent(soldOut ? "Out of Stock Product Selected" : "Product Selected", {
        product_category: category?.deviceSubType?.code,
        product_name: category?.name?.code
      })
    } catch (e) {
      console.log("Mixpanel Error:", e);
    }
    gtmPushSelectItemEvent()
    win.location.href = serverURL + prefix + technicalURL + `?deviceId=${id}`
    
    if (!window.location.hostname.includes('mobily.com.sa')) {
      if (window.location.href.includes('subsidy')) {
        win.location.href = serverURL + prefix + technicalURL + `?deviceId=${id}&presentationtemplate=PT-devices-subsidy-proj`
      }

      if (window.location.href.includes('gtm')) {
        win.location.href = serverURL + prefix + technicalURL + `?deviceId=${id}&presentationtemplate=PT-devices-gtm-proj`
      }
    }
  }

  return (
    <DeviceCard
      id={id}
      // data={props.data}
      title={title}
      price={price}
      deviceManufacturer={deviceManufacturer}
      image={serverURL + defaultURL}
      preOrderTag={preOrderTag}
      soldOut={soldOut}
      soldOutTag={soldOutTag}
      colors={colors}
      onCardClick={onCardClick}
    />
  )
}
export default Device
